















import { Component, Emit, Vue, Prop, Model, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import VueTagsInput from '@johmun/vue-tags-input';

@Component({
    components: {
        VueTagsInput
    }
})
export default class PropertySelector extends Vue {
    // Used to diaplays errors
    @Prop({ default: false }) public showError!: boolean;

    // additional class for wrapping div
    @Prop({ default: '' }) public wrapperClass!: string;

    // Enable/Disable changes
    @Prop({ default: false }) public disabled!: boolean;

    // Define the model for the v-model. In our case, it will be a CSV string
    @Model('on-model-changed', { type: String, default: '' }) private value!: string;

    // Add our VueX property store, and bind the store.propertis to component.propertyList
    @Getter('properties', { namespace: 'property' })
    private filteredPropertyList!: Array<{ text: string, code: string }>;

    @Getter('unfilteredProperties', { namespace: 'property' })
    private unfilteredPropertyList!: Array<{ text: string, code: string }>;

    private propertyList!: Array<{ text: string, code: string }>;

    private propertySelected: Array<{ text: string, code: string }> = [];
    private property: string = '';
    private propertyCSV: string = '';
    private placeHolder: string = 'Click to select';

    // Register events our Component can produce
    @Emit()
    public onChanged() {
        return Array<{ text: string }>();
    }

    @Emit()
    public onReady() { return; }

    public toggleSelection() {
        if (this.propertySelected.length === this.propertyList.length) {
            this.deselectAll();
        } else {
            this.selectAll();
        }
    }

    public toggleSelectionToolTip(): string {
        if (this.propertySelected.length === this.propertyList.length) {
            return 'Deselect All';
        } else {
            return 'Select All';
        }
    }

    private created() {
        // set property list
        if (this.disabled) {
            this.propertyList = this.unfilteredPropertyList;
        } else {
            this.propertyList = this.filteredPropertyList;
        }
    }

    private mounted() {
        // Since our Component Value is a CSV but the internal vue-tags-input is an object array
        // We will need to set our initial value one time.
        // Normally we could add immediage: true to the watcher, but we don't want to also emit the on-change
        // event the first time. Therefore we check if we have a value and set it internally when we are
        // mounted in Vue

        if (this.value && this.value.length > 0) {
            // Ok we have a value pending so we need to transform it for the vue-tags-input
            const newPropData = new Array<{ text: string, code: string }>();
            const newValues = this.value.split(',');
            newValues.forEach((propCode) => {
                propCode = propCode.trim();
                if (propCode.length < 1) { return; }

                const item = this.propertyList.find((p) => p.code === propCode);
                if (item) {
                    newPropData.push(item);
                }
            });
            this.propertySelected = newPropData;
            this.placeHolder = newPropData.length < 1 ? 'Click to select' : '';
        }
    }

    // Monitor changes to our Model / v-model / value
    @Watch('value')
    private onValueChange(newVal: string) {
        // On change we need to convert the CSV into an array of [ { text, code }]
        // To do this we will need to find the matching codes in the Property store
        // which we can access via the local Getter(propertyList)
        // then pass the array into the Watched propertySelected property of the vue-tags-input
        // that we bound.
        if (newVal === undefined) {
            console.log('PropertySelector model was undefined value');
            newVal = '';
        }

        const newValues = newVal.split(',');
        const newPropData = new Array<{ text: string, code: string }>();
        newValues.forEach((propCode) => {
            propCode = propCode.trim();
            if (propCode.length < 1) { return; }

            const item = this.propertyList.find((p) => p.code === propCode);
            if (item) {
                newPropData.push(item);
            }
        });
        this.propertySelected = newPropData;
        const newPropertyCSV = this.getPropertiesToCSV(newPropData);
        if (this.propertyCSV !== newPropertyCSV) {
            // and emit the model changed event
            console.log(`PropertySelector => watch(Value) old:${this.propertyCSV} new:${newPropertyCSV}`);
            this.propertyCSV = newPropertyCSV;
            this.$emit('on-model-changed', this.propertyCSV); // model changed
        }

        this.placeHolder = newPropData.length < 1  ? 'Click to select' : '';
    }

    // Used to filter the autocomplete list as items are added
    private filteredProperties() {
        return this.propertyList.filter((i: any) => {
            return i.text.toLowerCase().indexOf(this.property.toLowerCase()) !== -1 && i.text.length > 0;
        });
    }

    // Flatten the properties Array to the CSV string
    private getPropertiesToCSV(props: Array<{ text: string, code: string }>): string {
        let csv: string = '';
        props.forEach((t) => {
            if (csv.length === 0) {
                csv = `${t.code}`;
            } else {
                csv += `,${t.code}`;
            }
        });
        return csv;
    }

    // Our event handler for the vue-tags-input on-change event
    private handlePropertyChanged(newProps: Array<{ text: string, code: string }>) {
        this.placeHolder = newProps.length < 1 ? 'Click to select' : '';
        // Update our internal value
        this.propertySelected = newProps;
        // emit our change events
        this.$emit('on-changed', newProps); // array changed
        this.$emit('on-model-changed', this.getPropertiesToCSV(newProps)); // model changed
    }

    private selectAll() {
        const allPropData = new Array<{ text: string, code: string }>();
        this.propertyList.forEach((prop) => {
                allPropData.push(prop);
         });
        this.propertySelected = allPropData;
        this.$emit('on-changed', allPropData); // array changed
        this.$emit('on-model-changed', this.getPropertiesToCSV(allPropData)); // model changed
    }

    private deselectAll() {
        const emptyPropData = new Array<{ text: string, code: string }>();
        this.propertySelected = emptyPropData;
        this.$emit('on-changed', emptyPropData); // array changed
        this.$emit('on-model-changed', this.getPropertiesToCSV(emptyPropData)); // model changed
    }
}
